<template>
    <v-app id="layout" class="overflow-hidden" :style="'background-image: url(' +
        asset('images/header/liquid-cheese-bg.svg') +
        '); background-size: cover; background-position: center'
        ">
        <v-main>
            <div id="main" class="h-full layout-page-content">
                <router-view v-slot="{ Component }">
                    <v-slide-y-reverse-transition hide-absolute mode="out-in">
                        <component :is="Component" />
                    </v-slide-y-reverse-transition>
                </router-view>
            </div>
        </v-main>
    </v-app>
</template>

<script setup>
import { asset } from "@/mixins";
</script>
<style scoped>
.layout-page-content {
    inline-size: 100%;
    margin-inline: auto;
    max-inline-size: 1400px;
    min-width: 50vw;
}
</style>
